import Api, { baseURL, requestOptionsPOST } from '../api';
import newFetch from '../utils/newFetch';

const state = {
  user: {},
  logged: false
};

const getters = {
  getUserLogged: (state) => state.user,
  getLogged: (state) => state.logged,
  getRole: (state) => state.user.userToken.claims.map((role) => role.value)
};

const mutations = {
  setLogged(state, payload) {
    state.logged = payload;
  },
  setUserLogged(state, payload) {
    state.user = payload;
  }
};

const actions = {
  login(context, credentials) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.login, requestOptionsPOST(null, credentials))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  refreshToken(context, body) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.refreshToken, requestOptionsPOST(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
